import { mmFormConstants } from './form-constants';
import { TranslationGroup } from 'mm-web-core/i18n/tanslation-group';
import { zh, en } from './i18n';

export const mmFormTranslationGroup = {
    groupName: mmFormConstants.translationGroup,
    translations: {
        "zh": zh,
        "en": en
    }

} as TranslationGroup